export default __webpack_public_path__ + "static/media/beachhouse1.83f87382.jpg";